<template>
  <footer class="footer">
    <div class="footer-section">
      <div class="wrapper">
        <div class="left">
          <router-link to="/" class="logo">
            <img src="./../img/logo-dark.svg" class="img" />
          </router-link>
          <div class="text">
            <div class="desc" v-if="settings">{{ settings.requisites }}</div>
            <div class="methods">
              <div class="list list-pay">
				<img src="./../img/methods/mc.svg" class="img mc" />
                <img src="./../img/methods/visa.svg" class="img visa" />
				<img src="./../img/methods/3ds.svg" class="img 3ds" />
				<img src="./../img/methods/pci.svg" class="img pci" />
              </div>
            </div>
          </div>
        </div>
        <div class="right">
          <ul class="nav">
            <li class="nav__item">
              <router-link class="desc" to="/rules">
                <b>{{ $t("Rules") }}</b>
              </router-link>
            </li>
            <li class="nav__item">
              <button class="desc" @click="$parent.openContactUs()">
                <b>{{ $t("Contact us") }}</b>
              </button>
            </li>
            <li class="nav__item">
              <button
                @click="$emit('chooseCategoty', $parent.categories[0])"
                class="desc"
              >
                <b>{{ $t("Store") }}</b>
              </button>
            </li>
            <li class="nav__item">
              <router-link class="desc" to="/faq">
                <b>{{ $t("FAQ") }}</b>
              </router-link>
            </li>
            <template v-for="item in $parent.textPageList">
              <li class="nav__item" :key="item.id">
                <a class="desc" @click="$parent.goToPage(item)">
                  <b>{{ item.title }}</b>
                </a>
              </li>
            </template>
          </ul>
          <div>
            <a
              :href="'mailto:' + settings.support_email"
              class="desc small blue desc-email link-block"
              v-if="settings"
            >
              <b>{{ settings.support_email }}</b>
            </a>
            <a
              v-if="$parent.settings.support_phone"
              :href="
                'tel:' +
                (($parent.settings.support_phone &&
                  $parent.settings.support_phone.replace(/[\s()-]/g, '')) ||
                  '')
              "
              class="desc small blue desc-email link-block"
              style="margin-top: 10px"
            >
              <b>{{ $parent.settings.support_phone }}</b>
            </a>
          </div>
          <ul
            class="socials"
            v-if="$parent.socialLinks && $parent.socialLinks.length"
          >
            <li
              v-for="link in $parent.socialLinks"
              :key="link.img"
              class="nav__item nav__item-text-pages"
            >
              <a :href="link.link" class="desc" target="_blank">
                <img :src="link.img" :alt="link.link" class="img" />
              </a>
            </li>
          </ul>
          <div class="desc smallest" v-if="settings">
            {{ settings.copyright }}
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script>
export default {
  name: "Footer",
  props: ["settings"],
  data: function () {
    return {};
  },
  methods: {},
  mounted() {},
};
</script>
